const format = {

  // 格式化日期
  date(date: any, fmt: string) {
    if (!date || !fmt) {
      return date;
    }
    if (date.length == 8) {
      date = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`;
    }
    if (typeof date !== 'number' && date.length <= 20) { // 小于20 ，时间格式为  “yyyy-MM-dd hh:mm:ss” 有时分秒
      date = date.toString().replace(/-/g, '/');
    }

    date = new Date(date);

    interface oProps {
      'M+': number;
      'd+': number; // 日
      'h+': number; // 小时
      'm+': number; // 分
      's+': number; // 秒
      'q+': any; // 季度
      'S': number; // 毫秒
      [k: string]: any;
    }
    const o: oProps = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
    for (const k in o) if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
    return fmt;
  },
  guid(): string {
    return Math.random().toString(36).substr(5).toUpperCase();
  },
  digits(value: number, n = 2): any {
    if (isNaN(value)) {
      return false;
    }

    const f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }

    while (s.length <= rs + n) {
      s += '0';
    }

    return s;
    // return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
  },
  GetAgeByBirthday(birthday) {
    function parseDate(str) {
      const date = new Date();
      const times = str.split('-');
      date.setFullYear(times[0]);
      date.setMonth((times[1] - 1));
      date.setDate(times[2]);
      return date;
    }

    let age = -1;
    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1;
    const todayDay = today.getDate();
    const bday = parseDate(birthday);
    const birthdayYear = bday.getFullYear();
    const birthdayMonth = bday.getMonth() + 1;
    const birthdayDay = bday.getDate();

    if (todayYear - birthdayYear < 0) {
      alert('出生日期选择错误!');
    } else if (todayMonth - birthdayMonth > 0) {
      age = todayYear - birthdayYear;
    } else if (todayMonth - birthdayMonth < 0) {
      age = todayYear - birthdayYear - 1;
    } else if (todayMonth - birthdayMonth === 0) {
      if (todayDay - birthdayDay >= 0) {
        age = todayYear - birthdayYear;
      } else {
        age = todayYear - birthdayYear - 1;
      }
    }
    return age == 0 ? 1 : age;
  },
  GetQueryString(url: string) {
    const reg = new RegExp(`(^|&)${url}=([^&]*)(&|$)`);
    const r = window
      .location
      .search
      .substr(1)
      .match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },
  timeForMat(count) {
    // 拼接时间
    const time1 = new Date();
    time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000));
    const time2 = new Date();
    time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count));
    const Y2 = time2.getFullYear();
    const M2 = ((time2.getMonth() + 1) > 10 ? (time2.getMonth() + 1) : `0${time2.getMonth() + 1}`);
    const D2 = (time2.getDate() > 10 ? time2.getDate() : `0${time2.getDate()}`);
    const timer2 = `${Y2}-${M2}-${D2}`; // 之前的7天或者30天
    return timer2;
  },
  timeAdd(start, unit, value, fmt: string) {
    // 卡领取时指定有效期的值（card_effective_type=1时不能为空）
    // 卡领取指定有效期单位(1：天、2：月、3：年)（card_effective_type=1时不能为空）
    // 卡有效期类型（1：领取时指定有效期、2：固定有效期）
    const s = new Date(start).getTime();
    let e = new Date();
    if (unit == 1) {
      e = new Date(s + 1000 * 60 * 60 * 24 * value - 1000);  // 针对体检套餐失效，目前这个不通用
    } else if (unit == 2) {
      const nM = new Date().getMonth();
      (nM + value) > 11 ? e.setFullYear(new Date().getFullYear() + 1, (nM + value) % 11) : e.setFullYear(new Date().getFullYear(), (nM + value) % 11);
    } else if (unit == 3) {
      e.setFullYear(new Date().getFullYear() + value);
    }
    return format.date(e, fmt);
  },
  getText(item) {
    let text = '';
    const list: Array<string> = [];
    item.length && item.forEach((element) => {
      const { tags = [], additional = '', value = '无' } = element;
      let itemText = '';
      if (value === '有' && (additional !== '' || tags.length)) {
        itemText = tags.join('、');
        itemText = additional !== '' ? itemText.concat(` ${additional}`) : itemText;
      } else if (value === '无') {
        itemText = '无';
      } else if (value === '有') {
        itemText = '有';
      }
      list.push(itemText);
    });
    const newList = Array.from(new Set(list));

    if (newList.includes('无')) {
      text = '无';
    }
    if (newList.includes('有')) {
      text = '有';
    }
    if (newList.filter((i) => i !== '有' && i !== '无').length) {
      const arr = newList.filter((i) => i !== '有' && i !== '无');
      text = arr.join(' ');
    }

    return text;
  },
  toParse(data) {
    if (!data) {
      return '';
    } if (typeof data === 'string') {
      return JSON.parse(data);
    }
    return data;
  },
  noPassByMobile(str) {
    if (str) {
      const pat = /(\d{3})\d*(\d{4})/;
      return str.replace(pat, '$1****$2');
    }
    return '';
  },
  merge(target, ...arg) {
    const isObject = (obj) => (Object.prototype.toString.call(obj) === '[object Object]');
    const isArray = (arr) => (Array.isArray(arr));
    return arg.reduce((acc, cur) => {
      return Object.keys(cur).reduce((subAcc, key) => {
        const srcVal = cur[key];
        if (isObject(srcVal)) {
          subAcc[key] = format.merge(subAcc[key] ? subAcc[key] : {}, srcVal);
        } else if (isArray(srcVal)) {
          // series: []，下层数组直接赋值
          subAcc[key] = srcVal.map((item, idx) => {
            if (isObject(item)) {
              const curAccVal = subAcc[key] ? subAcc[key] : [];
              return format.merge(curAccVal[idx] ? curAccVal[idx] : {}, item);
            }
            return item;
          });
        } else {
          subAcc[key] = srcVal;
        }
        return subAcc;
      }, acc);
    }, target);
  },
  zeroPad: (value) => {
    if (value < 10) {
      return `0${value}`;
    }
    return value;
  },
};

export default format;
